/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

const TEST_CONFIG = {
  active: false,
  finished: false,
  alternatives: [
    'control',
    'original_landing',
    'blurred_landing',
    'new_landing',
  ],
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * growth_2026_q2_citations_dashboard
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base('growth_2026_q2_citations_dashboard', TEST_CONFIG);
}

/**
 * React hook to return the bucket for this A/B test:
 * growth_2026_q2_citations_dashboard
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base('growth_2026_q2_citations_dashboard', TEST_CONFIG);
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * growth_2026_q2_citations_dashboard
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base(
    'growth_2026_q2_citations_dashboard',
    TEST_CONFIG,
  );
}

// MD5 hash of test's YAML config; modification will fail commit hook
// 300f1ee069d032954feae5a1ff2a31fb
